"use strict";

define('view/assign.review.type.overlay',['require','exports','module','underscore','marionette','uikit/uikit','libs/format/empty','service/assignment','collection/base','templates'],function (require, exports, module) {
  var _ = require('underscore');
  var Mn = require('marionette');
  var UIKit = require('uikit/uikit');
  var EmptyFormatter = require('libs/format/empty');
  var AssignmentService = require('service/assignment');
  var BaseCollection = require('collection/base');
  var Templates = require('templates');
  var emptyFormat = EmptyFormatter('--');
  var AssignReviewTypeOverlay = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    className: 'ui grid',
    template: Templates.IRB['assign.overlay'],
    useInjector: true,
    initialize: function initialize() {
      UIKit.ComponentMixin.initialize.apply(this, arguments);
      this.setupForm();
      this.setupFormListeners();
      this.setupInitialValues();
    },
    setupForm: function setupForm() {
      var form = this.form,
        reviewTypeOps = {
          collection: new BaseCollection(AssignmentService.ReviewTypes),
          childBindings: {
            text: 'description'
          },
          name: 'reviewType',
          placeholder: 'Select a Review Type',
          clearable: true
        },
        isFullExpeditedOps = {
          name: 'isFullExpedited',
          toggle: true,
          polar: true
        },
        reviewerTypeOps = {
          collection: new BaseCollection(AssignmentService.ReviewerTypes),
          childBindings: {
            text: 'description'
          },
          name: 'reviewerType',
          placeholder: 'Select One',
          clearable: true
        },
        boardOps = {
          collection: this.options.boards,
          childBindings: {
            text: 'name'
          },
          name: 'board',
          search: true,
          placeholder: 'Select a Board',
          clearable: true
        },
        boardRosterOps = {
          name: 'boardRoster',
          columns: [{
            text: 'Name',
            data: 'personDisplayName'
          }, {
            text: 'Membership',
            data: 'membership',
            formatter: emptyFormat
          }, {
            text: 'Degrees',
            data: 'degrees',
            formatter: emptyFormat
          }, {
            text: 'Status',
            data: 'scientificStatus',
            formatter: emptyFormat
          }, {
            text: 'Representation',
            data: 'representation',
            formatter: emptyFormat
          }, {
            text: 'Affiliation',
            data: 'affiliation',
            formatter: emptyFormat
          }, {
            text: 'Office',
            data: 'office',
            formatter: emptyFormat
          }],
          sortable: false,
          tabletStackable: true
        };
      var submission = this.getOption('submission');
      var isPre2018Rule = submission.get('commonRulePolicy') !== 'POST2018RULE';
      var isIncident = submission.get('templateType') === 'Incident';
      if (isPre2018Rule || isIncident) {
        var limitedIRBModel = reviewTypeOps.collection.findWhere({
          value: 'LIMITED'
        });
        reviewTypeOps.collection.remove(limitedIRBModel);
      }
      this.reviewTypeField = form.addField({
        text: 'Review Type',
        required: true
      }, new UIKit.Dropdown(reviewTypeOps));
      this.isFullExpeditedField = form.addField({
        text: 'Is this a full expedited review?',
        visible: false
      }, new UIKit.Checkbox(isFullExpeditedOps));
      this.reviewerTypeField = form.addField({
        text: 'Are you choosing a Board Member or an Analyst?',
        visible: false,
        required: true
      }, new UIKit.Dropdown(reviewerTypeOps));
      this.boardField = form.addField({
        text: 'Review Board',
        visible: false,
        required: true
      }, new UIKit.Dropdown(boardOps));
      this.overseeingBoardField = form.addField({
        text: 'Which Board would you like to oversee this submission?',
        visible: false,
        required: true
      }, new UIKit.Dropdown(_.extend({}, boardOps, {
        name: 'overseeingBoard'
      })));
      this.boardRosterContainer = new UIKit.Container({
        className: 'ui fitted basic segment'
      });
      this.boardRosterContainer.add(new UIKit.Table(boardRosterOps));
      this.boardRosterField = form.addField({
        text: 'Review Board Roster',
        visible: false
      }, this.boardRosterContainer);
    },
    setupInitialValues: function setupInitialValues() {
      var form = this.form,
        assignments = this.options.assignments,
        reviewType = assignments.getByAssignmentTypeProp('IRB_REVIEW_TYPE', 'description').models[0],
        isFullExpedited = assignments.getByAssignmentTypeProp('IRB_IS_FULL_EXPEDITED', 'description').models[0],
        reviewerType = assignments.getByAssignmentTypeProp('IRB_FULL_EXPEDITED_REVIEW_TYPE', 'description').models[0] || assignments.getByAssignmentTypeProp('IRB_EXEMPT_TYPE', 'description').models[0],
        board = assignments.getByAssignmentTypeProp('IRB_BOARD', 'description').models[0];
      if (this.isClosure()) {
        if (board) {
          var foundBoard = form.board.collection.findWhere({
            id: board.get('group.id')
          });
          form.overseeingBoard.value = foundBoard;
        }
        this.overseeingBoardField.visible = true;
        this.reviewTypeField.visible = false;
      } else if (reviewType) {
        form.isFullExpedited.value = isFullExpedited.get('value') == 'true';
        form.reviewType.value = form.reviewType.collection.findWhere({
          value: reviewType.get('value')
        });
        if (reviewerType) {
          form.reviewerType.value = form.reviewerType.collection.findWhere({
            value: reviewerType.get('value')
          });
        }
        if (board) {
          var foundBoard = form.board.collection.findWhere({
            id: board.get('group.id')
          });
          if (reviewerType && reviewerType.get('value') == 'IRB_ANALYST') {
            form.overseeingBoard.value = foundBoard;
          } else {
            form.board.value = foundBoard;
          }
        }
      }
      this._initialValuesSet = true;
    },
    getAssignments: function getAssignments() {
      var form = this.form,
        reviewType = form.reviewType.value ? form.reviewType.value.get('value') : null,
        isFullExpedited = form.isFullExpedited.value ? 'true' : 'false',
        reviewerType = form.reviewerType.value ? form.reviewerType.value.get('value') : null,
        board = form.board.value || form.overseeingBoard.value || null,
        fullExpeditedType = reviewType == 'FULL' && isFullExpedited == 'true' ? reviewerType : null,
        exemptType = reviewType == 'EXEMPT' ? reviewerType : null;
      return {
        property: [{
          type: 'IRB_REVIEW_TYPE',
          value: reviewType
        }, {
          type: 'IRB_IS_FULL_EXPEDITED',
          value: isFullExpedited
        }, {
          type: 'IRB_FULL_EXPEDITED_REVIEW_TYPE',
          value: fullExpeditedType
        }, {
          type: 'IRB_EXEMPT_TYPE',
          value: exemptType
        }],
        group: [{
          type: 'IRB_BOARD',
          group: board
        }]
      };
    },
    resetValues: function resetValues() {
      var form = this.form;
      form.boardRoster.collection = null;
      form.board.value = null;
      form.reviewerType.value = null;
      form.isFullExpedited.value = null;
      form.overseeingBoard.value = null;
    },
    setupFormListeners: function setupFormListeners() {
      var form = this.form;
      this.listenTo(form.reviewType, 'change:value', function (reviewTypeView, reviewType, oldReviewType) {
        if (this._initialValuesSet) {
          this.resetValues();
        }
        this.isFullExpeditedField.visible = false;
        this.reviewerTypeField.visible = false;
        this.boardField.visible = false;
        this.boardRosterField.visible = false;
        this.overseeingBoardField.visible = false;
        switch (reviewType && reviewType.get('value')) {
          case 'FULL':
            var isFullExpedited = form.isFullExpedited.value;
            this.isFullExpeditedField.visible = true;
            if (isFullExpedited) {
              this.reviewerTypeField.visible = true;
            } else {
              this.boardField.visible = true;
              this.boardRosterField.visible = true;
            }
            break;
          case 'EXPEDITED':
          case 'LIMITED':
          case 'ADMINISTRATIVE':
            this.boardField.visible = true;
            this.boardRosterField.visible = true;
            break;
          case 'EXEMPT':
            this.reviewerTypeField.visible = true;
            break;
        }
      });
      this.listenTo(form.isFullExpedited, 'change:value', function (isFullExpeditedView, isFullExpedited) {
        var reviewType = form.reviewType.value;
        if (this._initialValuesSet) {
          form.reviewerType.value = null;
          form.board.value = null;
          form.overseeingBoard.value = null;
        }
        if (reviewType && reviewType.get('value') == 'FULL') {
          this.reviewerTypeField.visible = false;
          this.boardField.visible = false;
          this.overseeingBoardField.visible = false;
          this.boardRosterField.visible = false;
          if (isFullExpedited) {
            this.reviewerTypeField.visible = true;
          } else {
            this.boardField.visible = true;
            this.boardRosterField.visible = true;
          }
        }
      });
      this.listenTo(form.reviewerType, 'change:value', function (reviewerTypeView, reviewerType) {
        if (this._initialValuesSet) {
          form.board.value = null;
          form.overseeingBoard.value = null;
        }
        switch (reviewerType && reviewerType.get('value')) {
          case 'IRB_BOARD':
            this.boardField.visible = true;
            this.boardRosterField.visible = true;
            this.overseeingBoardField.visible = false;
            break;
          case 'IRB_ANALYST':
            this.overseeingBoardField.visible = true;
            this.boardRosterField.visible = true;
            this.boardField.visible = false;
            break;
          default:
            this.boardField.visible = false;
            this.boardRosterField.visible = false;
            this.overseeingBoardField.visible = false;
            break;
        }
      });
      this.listenTo(form.board, 'change:value', function (boardView, board) {
        this.updateBoardRosterWithBoard(board);
      });
      this.listenTo(form.overseeingBoard, 'change:value', function (overseeingBoardView, board) {
        this.updateBoardRosterWithBoard(board);
      });
    },
    updateBoardRosterWithBoard: function updateBoardRosterWithBoard(board) {
      var form = this.form;
      if (board) {
        var members = board.members();
        form.boardRoster.collection = members;
        this.boardRosterContainer.$el.addClass('loading');
        members.fetch().promise().bind(this)["finally"](function () {
          this.boardRosterContainer.$el.removeClass('loading');
        });
      } else {
        form.boardRoster.collection = null;
      }
    },
    isClosure: function isClosure() {
      var submission = this.getOption('submission');
      return app.service('submission').isClosure(submission);
    }
  });
  module.exports = AssignReviewTypeOverlay;
});

